/**
 * Created by Ninghai on 2017/12/19.
 */
import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

Vue.use(Vuex)
const state = {
  hasLogin: false,
  user_id: undefined,
  username: undefined,
  token: undefined,
  recoverPasswordSuccess: false,
  jobList: [],
  isLoading: false,
  showMessage: false,
  globalMessage: {type: 'warning', title: '错误测试', content: ''},
  unPurchaseMessage: '',
  companyList: [],
  unlistedCompanyDataDate: '',
  nextPurchaseTarget: {
    renewable: false,
    id: undefined,
    type: 'unlisted'
  },
  nextTargetCompany: undefined,
  charts: {},
  isNoData: false,
  weChatCount: '',
  orderId: '',
  whiteList: {},
  defaultActiveIndex: [],
  strctureMatrix: [],
  defaultActiveApiLink: 'introduction',
  showLoadingAnimation: false,
  showNewIndex: true,
  emotionObject: {
    individualStock: {},
    stockRainkList: [],
    singleRockList: [],
    loading: {
      leftLoading: true,
      rightLoading: true
    }
  },//情绪指数包含的信息
  retailersObject: [],
  retailersObject2: [],
  showReport: true,//是否展示财报
  dateType: 'quarter',//默认显示的日期类型,
  dateTypeLive: 'quarter',
  liveData: [],
  //品牌馆
  brandObject:[],

  //15万天猫
  
  
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js